import { render, staticRenderFns } from "./WorkflowImportPage.vue?vue&type=template&id=2a804a94&scoped=true"
import script from "./WorkflowImportPage.vue?vue&type=script&lang=js"
export * from "./WorkflowImportPage.vue?vue&type=script&lang=js"
import style0 from "./WorkflowImportPage.vue?vue&type=style&index=0&id=2a804a94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a804a94",
  null
  
)

export default component.exports